import './style.scss';
import Testimonial from '../../Pages/Customer/Testimonial';
import { useState } from 'react';
import {AiOutlinePlusCircle,AiOutlineMinusCircle} from 'react-icons/ai';
import { questions } from './data';
function FaqApp(){
    return(
        <div className="faq-app">
            <div className="content">
                <div className="feedback">
                <h1>Everybody loves working with us</h1>
                <p>Here's what our customers have to say about us.</p>
                <Testimonial />
                </div>
                <div className="faq">

                <h1>FAQ</h1>
                {questions.map((d) =>{
                    return(
                        <Faqitem {...d}/>
                    )
                } )}
                </div>
            </div>
        </div>
    )
};
export default FaqApp ;
export function Faqitem(props){
    const [answer,setAnswer]= useState(false);
    function show(){
        setAnswer(!answer)
    }
    return(
        <div className="faq-item" onClick={show}>
            <h3>{props.question} <div> {answer===false ? <AiOutlinePlusCircle /> : <AiOutlineMinusCircle />} </div> </h3>
            {answer === true &&
            <p>{props.answer}</p>
            }
        </div>
    )
};